const userNameRegExp = /^[a-zA-Z][0-9a-zA-Z_]{2,23}[0-9a-zA-Z]$/;
const phoneRegExp = /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/;

export { userNameRegExp, phoneRegExp };
